<template>
  <div class="loader-wrapper">
    <div class="left-side">
      <v-skeleton-loader
        type="heading"
        width="200px"
        class="mb-2"
      />
      <div v-for="num in 2" :key="num">
        <v-skeleton-loader
          type="text"
          width="150px"
        />
        <v-skeleton-loader
          type="paragraph@2"
        />
      </div>
    </div>
    <div class="right-side">
      <v-skeleton-loader
        type="heading"
        width="200px"
      />
      <v-skeleton-loader
        type="paragraph"
      />
    </div>
  </div>
</template>

<style lang="less" scoped>
.loader-wrapper {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 400px;
  height: 100%;
}

.left-side {
  padding: 36px 150px 36px 60px;
  border-right: 1px solid @stroke-default;
  height: 100%;
}

.right-side {
  padding: 36px;
  height: 100%;
}
</style>
